import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgMailSendLine = (props) => /* @__PURE__ */ _jsx("svg", {
	width: "1em",
	height: "1em",
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M20 4C21.0544 4 21.9182 4.81588 21.9945 5.85074L22 6V18C22 19.0544 21.1841 19.9182 20.1493 19.9945L20 20H4C2.94564 20 2.08183 19.1841 2.00549 18.1493L2 18V17H4V18H20V7.41437L13.0607 14.3536C12.5116 14.9028 11.6425 14.9371 11.0533 14.4566L10.9394 14.3536L4 7.41421V8H2V6C2 4.94564 2.81588 4.08183 3.85074 4.00549L4 4H20ZM6 13C6.55228 13 7 13.4477 7 14C7 14.5523 6.55228 15 6 15H1C0.447715 15 0 14.5523 0 14C0 13.4477 0.447715 13 1 13H6ZM18.5859 6H5.41421L12.0001 12.5859L18.5859 6ZM5 10C5.55228 10 6 10.4477 6 11C6 11.5128 5.61396 11.9355 5.11662 11.9933L5 12H2C1.44772 12 1 11.5523 1 11C1 10.4872 1.38604 10.0645 1.88338 10.0067L2 10H5Z",
		fill: "black"
	})
});
export default SvgMailSendLine;
